import { FocusLayout } from '@components/FocusLayout'
import { lazy } from 'solid-js'

const Join = lazy(() => import('./Join'))
const Welcome = lazy(() => import('./Welcome'))

// function Container(props: ParentProps) {
//   return <Box height='calc(var(--vh) * 100 - 76px)'>
//     {props.children}
//   </Box>
// }

const routes = [
  {
    path: '/onboarding',
    component: FocusLayout,
    children: [
      {
        path: '/',
        component: Join,
      },
      {
        path: '/welcome',
        component: Welcome,
      },
    ],
  },
]

export default routes
